
import React from 'react';
import GenericTableEditor from '../../components/admin/GenericTableEditor';

const MembershipsEditor = () => {
  const columns = [
    { key: 'name', label: 'Name', type: 'text' },
    { key: 'description_en', label: 'Description (EN)', type: 'textarea' },
    { key: 'description_ms', label: 'Description (MS)', type: 'textarea' },
    { key: 'logo', label: 'Logo URL', type: 'image' },
  ];

  return <GenericTableEditor tableName="memberships" columns={columns} title="Memberships Manager" />;
};

export default MembershipsEditor;
